import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { CollateralSkillSet } from '../collateralskillset.model';
import { CollateralskillsetsService } from '../collateralskillsets.service';

@Component({
  selector: 'app-skillset-list',
  templateUrl: './skillset-list.component.html',
  styleUrls: ['./skillset-list.component.css']
})
export class SkillsetListComponent implements OnInit {

    public skillsets: CollateralSkillSet[] = [];
    @Output() updated = new EventEmitter<any>();
    constructor(private collateralSkillsetservice: CollateralskillsetsService) { }

    async ngOnInit() {
        this.skillsets = await this.collateralSkillsetservice.getCollateralSkillsets();
        this.collateralSkillsetservice.skillsetAdded
            .subscribe((skillset: CollateralSkillSet) => {
                this.skillsets.push(skillset);
            });
        this.collateralSkillsetservice.skillsetUpdated
            .subscribe((skillset: CollateralSkillSet) => {
                this.skillsets.find(x => x.id === skillset.id).name = skillset.name;
                this.skillsets.find(x => x.id === skillset.id).productSkillsetId = skillset.productSkillsetId;
                this.updated.emit(false);
            });
        this.collateralSkillsetservice.skillsetDeleted
            .subscribe((skillsetId: string) => {
                var skillsetIndex = this.skillsets.findIndex(t => t.id === skillsetId);
                this.skillsets.splice(skillsetIndex, 1);
            });
    }

}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/collateralskillsets/skillset-list/skillset-list.component.ts